<div class="p-grid table-demo manage-tournament-section admin-wallet-redemtion"
  [ngClass]="hide ? 'hide-bank-small  ' : 'show-bank-details-section '">
  <div class="p-col-12">
    <p-toast key="toastmsg"></p-toast>
    <div class="card show-table-active" [ngClass]="hide ? 'show-table-active   ' : 'show-table-active  '">
      <p-toast key="toastmsg"></p-toast>
      <h3>Academy Tournament Report</h3>
      <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
          <!-- <button pButton pRipple label="New" icon="pi pi-plus" class="p-button-success p-mr-2 p-mb-2"
                          (click)="addNewTournament()"></button> -->
          <button pButton label="Clear Filters" class="p-button-outlined p-mr-2 p-mb-2" icon="pi pi-filter-slash"
            (click)="clear()"></button>
        </ng-template>
        <ng-template pTemplate="right">
          <button pButton pRipple label="Export" icon="pi pi-file-excel" (click)="exportExcel()"
            class="p-button-help mr-2" pTooltip="XLS" tooltipPosition="bottom"></button>
          <!-- <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()" class="p-button-warning mr-2" pTooltip="PDF" tooltipPosition="bottom"></button> -->
        </ng-template>
      </p-toolbar>
      <div class="card">
        <div class="p-fluid p-formgrid p-grid align-items-end">
          <div class="p-field p-col-12 p-mb-0">
            <h5>Filter</h5>
          </div>
          <div class="p-field p-col-2">
            <label for="searchfield">Select Field</label>
            <p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby" placeholder="Select Field"
              optionLabel="label"></p-dropdown>
          </div>
          <div class="p-field p-col-2">
            <label for="startdt">Start Date</label>
            <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="startDate"
              class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy"></p-calendar>
          </div>
          <div class="p-field p-col-2">
            <label for="enddt">End Date</label>
            <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="endDate"
              class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy"></p-calendar>
          </div>
          <div class="p-field p-col-1">
            <button pButton pRipple label="Search" class="p-button p-mr-1 p-mb-"
              (click)="loadAcademiesTournament($event)"></button>
          </div>
        </div>
      </div>
    </div>
    <p-table class="p2-table-columns show-columns" #dt [value]="academiesList" [paginator]="true" [rows]="10"
      [lazy]="true" (onLazyLoad)="loadAcademiesTournament($event)" [totalRecords]="totalRecords" [loading]="loading"
      [rowsPerPageOptions]="paginationOption" styleClass="p-datatable-gridlines p-datatable-striped">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th pfrozencolumn="" class="p-element p-frozen-column col-150 text-nowrap" style="left: 0px;"
            pSortableColumn="name">
            <div class="p-d-flex p-jc-between p-ai-center">
              Name of the Academy
              <p-sortIcon field="name"></p-sortIcon>
            </div>
          </th>
          <th class="col-180" pSortableColumn="tournamentCount">
            <div class="p-d-flex p-jc-between p-ai-center">
              Number of Tournaments conducted
              <p-sortIcon field="tournamentCount"></p-sortIcon>
            </div>
          </th>
          <th class="col-150" pSortableColumn="tournamentName">
            <div class="p-d-flex p-jc-between p-ai-center">
              Name of the Tournament
              <p-sortIcon field="tournamentName"></p-sortIcon>
            </div>
          </th>
          <th class="col-150" pSortableColumn="tournamentCategoriesData">
            <div class="p-d-flex p-jc-between p-ai-center">
              Tournament Categories
              <p-sortIcon field="tournamentCategoriesData"></p-sortIcon>
            </div>
          </th>
          <th class="text-nowrap p-element p-frozen-column" pfrozencolumn="" alignfrozen="right"
            style="width: 120px; right: 0px;">
            <div class="p-d-flex p-jc-between p-ai-center">
              Action
            </div>
          </th>
        </tr>
        <tr>
          <th [ngSwitch]="name" pfrozencolumn="" class="p-element p-frozen-column col-150 text-nowrap"
            style="left: 0px;">
            <input pInputText type="text"
              (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'name', 'contains')"
              [value]="dt.filters['name'] ? dt.filters['name'].value : ''" />
          </th>
          <th [ngSwitch]="tournamentCount" class="col-180">
            <input pInputText type="text"
              (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'tournamentCount', 'contains')"
              [value]="dt.filters['tournamentCount'] ? dt.filters['tournamentCount'].value : ''" />
          </th>
          <th [ngSwitch]="tournamentName" class="col-150">
            <input pInputText type="text"
              (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'tournamentName', 'contains')"
              [value]="dt.filters['tournamentName'] ? dt.filters['tournamentName'].value : ''" />
          </th>
          <th [ngSwitch]="tournamentCategoriesData" class="col-150">
            <input pInputText type="text"
              (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'tournamentCategoriesData', 'contains')"
              [value]="dt.filters['tournamentCategoriesData'] ? dt.filters['tournamentCategoriesData'].value : ''" />
          </th>
          <th class="p-element p-frozen-column" pfrozencolumn="" alignfrozen="right" style="width: 120px; right: 0px;">
            <!-- <button pButton [style]="{'margin-left':'20px'}" icon="pi pi-plus" class="p-button-rounded" (click)="addColumns()"></button> -->
            <!-- <button pButton pRipple label="Columns" icon="pi pi-plus"
    								[ngClass]="hide ? 'show-col p-button p-button-primary p-button-rounded ' : 'hide-col p-button-secondary p-button-rounded'"
    								(click)="setDownloadFlag(); addColumns()"></button>
    							<button pButton pRipple label="Columns" icon="pi pi-minus"
    								[ngClass]="hide ? 'hide-col p-button p-button-rounded' : 'show-col p-button p-button-rounded'"
    								(click)="setDownloadFlag(); removeColumns()"></button> -->
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-academy>
        <tr class="p-selectable-row">
          <td pfrozencolumn="" class="p-element p-frozen-column col-150 text-nowrap" style="left: 0px; z-index: 1001;">
            <div class="d-flex">
              <span class="name" pTooltip="{{academy.name}}">{{academy.name}}</span>
            </div>
          </td>
          <td class="col-180">
            {{academy.tournamentCount}}
          </td>
          <td class="col-150">
            <div>
                <p-table [value]="academy.tournamentData">
                  <ng-template pTemplate="body" let-tournament>
                      <tr class="p-selectable-row">
                                <td>
                                  {{tournament.name}}
                                </td>
                                <td>
                                  <div *ngIf="tournament.tournamentCategoriesData !== undefined">
                                    <p-table #tournamentCategoriesId [value]="tournament.tournamentCategoriesData">
                                      <ng-template>
                                        <tr class="p-selectable-row">
                                          <th>
                                            Category Wise
                                          </th>
                                          <th>
                                            Registrations in each category
                                          </th>
                                        </tr> 
                                      </ng-template>
                                      <ng-template pTemplate="body" let-tournamentCategories>
                                        <tr class="p-selectable-row">
                                          <td>
                                            {{tournamentCategories?.matchTypeData[0]?.name}} {{tournamentCategories?.ageGroupData[0]?.name}} 
                                          </td>
                                          <td>
                                            registrationCount
                                          </td>
                                        </tr>
                                      </ng-template>
                                    </p-table>
                                  </div>
                                </td>
                            <td>
                        </td>
                      </tr>
                  </ng-template>
                </p-table>
            </div>
          </td>
          <td>
            <!-- <div *ngFor="let tournamentCategories of academy.tournamentData">
              <p-table [value]="tournamentCategories.tournamentCategoriesData">
                <ng-template pTemplate="body" let-tournamentCategories>
                  <tr class="p-selectable-row">
                    <td>
                      {{tournamentCategories.length}}
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div> -->

          </td>
          <td></td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="7">Academy not found.</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="summary">
        <div class="p-d-flex p-ai-center p-jc-between">
          In total there are {{totalRecords }} Academies.
        </div>
      </ng-template>
    </p-table>
</div>
</div>